import * as React from 'react';
import styled from 'styled-components';

interface IBearingRangeAreaProps {
  style?: any;
}

const TableContainer = styled.table``;
const TableHead = styled.thead``;
const TableBody = styled.tbody``;
const TableHeadCell = styled.tr`
  padding: 2px;
  text-align: left;
`;
const TableRow = styled.tr``;
const TableRowCell = styled.td`
  padding: 2px;
`;

const BearingRangeArea: React.FunctionComponent<IBearingRangeAreaProps> = (
  props
) => {
  return (
    <TableContainer {...props}>
      <TableHead>
        <TableHeadCell>
          <TableRowCell></TableRowCell>
          <TableRowCell>Brg</TableRowCell>
          <TableRowCell>Rng</TableRowCell>
        </TableHeadCell>
      </TableHead>
      <TableBody>
        <TableRow>
          <TableRowCell>{'own->cur'}</TableRowCell>
          <TableRowCell>299R</TableRowCell>
          <TableRowCell>1830 Yds ( 1673 m)</TableRowCell>
        </TableRow>
        <TableRow>
          <TableRowCell>own->pri</TableRowCell>
          <TableRowCell></TableRowCell>
          <TableRowCell></TableRowCell>
          <TableRowCell></TableRowCell>
        </TableRow>
        <TableRow>
          <TableRowCell>own->sec</TableRowCell>
          <TableRowCell></TableRowCell>
          <TableRowCell></TableRowCell>
          <TableRowCell></TableRowCell>
        </TableRow>
        <TableRow>
          <TableRowCell>pri->sec</TableRowCell>
          <TableRowCell></TableRowCell>
          <TableRowCell></TableRowCell>
          <TableRowCell></TableRowCell>
        </TableRow>
      </TableBody>
    </TableContainer>
  );
};

export default BearingRangeArea;
